import { financeDataApi1 } from '@subaio/api-specs'

import { asContainer } from 'lib/container'

import { OpenApi } from 'components/OpenApi'

type State = {}

export const container = asContainer<State>()({
	path: '/apis/finance-data-api/v1',
	title: 'Finance Data API',
	authentication: { type: 'public' },
	Running: ({ statuspageApi }) => <OpenApi apiDocument={financeDataApi1} statuspageApi={statuspageApi} />,
})
